import React from 'react';
import { SvgIcon, SvgIconProps, SxProps, Theme } from '@mui/material';

interface IconProps extends Omit<SvgIconProps, 'color' | 'fontSize'> {
  color?: string;
  fontSize?: number | string;
  svg: React.ReactNode;
  viewBox?: string;
  sx?: SxProps<Theme>;
}

const Icon = React.memo(
  ({
    color = 'inherit',
    fontSize = 14,
    svg,
    viewBox = '0 0 600 600',
    sx = {},
    ...props
  }: IconProps) => {
    if (!svg) return null;
    return (
      <SvgIcon
        sx={{
          fontSize: fontSize,
          fill: color,
          ...sx,
        }}
        shapeRendering="geometricPrecision"
        viewBox={viewBox}
        {...props}
      >
        {svg}
      </SvgIcon>
    );
  }
);

Icon.displayName = 'Icon';

export default Icon;
